


























































import { defineComponent, ref } from "@vue/composition-api";
import SelectFilter from "@monorepo/uikit/src/components/common/Select/SelectFilter.vue";
import TextFilter from "@monorepo/uikit/src/components/tableViews/TextFilter.vue";
import DatePicker from "@monorepo/uikit/src/components/tableViews/DatePicker.vue";
import TimePicker from "@monorepo/uikit/src/components/tableViews/TimePicker.vue";
import { filtersElements } from "@monorepo/utils/src/variables/projectsData/systemNotificationsList/filtersElements";
import { currentFilters as setCurrentFilters } from "../utils/defaultCurrentFilters";
import { mapActions, mapGetters } from "vuex";
import { viewUniqKey } from "@monorepo/utils/src/variables/projectsData/systemNotificationsList/viewTitle";
import { fields } from "@monorepo/utils/src/variables/projectsData/systemNotificationsList/fields";
import { elementStatuses } from "@monorepo/utils/src/variables/elementStatuses";
import FindButton from "@monorepo/uikit/src/components/tableViews/FindButton.vue";
import ToggleFilters from "@monorepo/uikit/src/components/tableViews/ToggleFilters.vue";
import ClearFilters from "@monorepo/uikit/src/components/tableViews/ClearFilters.vue";
import { convertToSelectItems } from "@monorepo/utils/src/utils/convertToSelectItems";
import useTemplateFilters from "@monorepo/utils/src/composables/useTemplateFilters";
import useFilter from "@monorepo/utils/src/composables/useFilter";

export default defineComponent({
  components: {
    SelectFilter,
    TextFilter,
    DatePicker,
    TimePicker,
    FindButton,
    ToggleFilters,
    ClearFilters,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    sectionName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      filtersElements,
      viewUniqKey,
      fields,
      elementStatuses,
    };
  },
  computed: {
    ...mapGetters("systemNotificationsList", [
      "fieldFilters",
      "triggersLibrary",
      "transportsLibrary",
      "searchTemplates",
      "isTableLoading",
      "isLoadingToggleFilters",
    ]),
    triggersLibraryResult(): { title: string; value: string }[] {
      return convertToSelectItems(this.triggersLibrary, "description", "name");
    },
    transportsLibraryResult(): { title: string; value: string }[] {
      return convertToSelectItems(this.transportsLibrary, "description", "name");
    },
  },
  methods: {
    ...mapActions("systemNotificationsList", ["clearFilters", "addFilter", "refreshScroll", "saveSearchTemplates"]),
    setCurrentFilters,
  },
  setup(props, context) {
    const { root } = context;
    const currentFilters = ref((setCurrentFilters as () => Record<string, unknown>)());
    const notHiddenKeys = ref([] as string[]);
    const isShowToggle = ref(false);
    const autocompleteItemsResultLists = ref({} as { [key: string]: Record<string, unknown>[] });
    const isLoadingAutocomplete = ref(false);
    useTemplateFilters(root, props.sectionName, currentFilters);
    const { filter, hiddenRowsStyleObj, openHiddenFilterOnStart, toggleOpenFilter, clearFiltersCb, refresh, updateFiltersDivHeight } = useFilter(
      context,
      props,
      props.sectionName,
      {},
      currentFilters,
      setCurrentFilters,
      filtersElements as { value: string; title: string }[],
      notHiddenKeys,
      isShowToggle
    );

    return {
      filter,
      hiddenRowsStyleObj,
      openHiddenFilterOnStart,
      toggleOpenFilter,
      clearFiltersCb,
      refresh,
      updateFiltersDivHeight,
      currentFilters,
      notHiddenKeys,
      isShowToggle,
      autocompleteItemsResultLists,
      isLoadingAutocomplete,
    };
  },
});
